export function parseOptionalNonNegativeNumber(value, label) {
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }
    const parsed = +trimmed;
    if (!Number.isFinite(parsed) || parsed < 0) {
        return `${label} must be a non-negative number.`;
    }
    return parsed;
}
//# sourceMappingURL=parse-optional-non-negative-number.js.map